import React, { useState } from 'react';
import '../CSS/Contact.css';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
  };

  const contactItems = [
    {
      icon: '✉️',
      title: 'Email',
      value: 'Contact@codewithvijay.net',
      link: 'mailto:hello@codewithvijay.net',
    },
    {
      icon: '🐦',
      title: 'Twitter / X',
      value: '@codewithvijay',
      link: 'https://twitter.com',
    },
    {
      icon: '💼',
      title: 'LinkedIn',
      value: 'linkedin.com/in/vijay',
      link: 'https://linkedin.com',
    },
    {
      icon: '📺',
      title: 'YouTube',
      value: '@codewithvijay',
      link: 'https://youtube.com',
    },
  ];

  return (
    <main className="contact-page">
      <div className="container">
        <div className="contact-hero">
          <span className="section-label">Get in touch</span>
          <h1 className="contact-hero__title">Let's Talk</h1>
          <p className="contact-hero__desc">
            Whether you have a question, feedback, sponsorship inquiry, or just want to say hi — I'd love to hear from you.
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-info">
            <h2 className="contact-info__title">Other ways to reach me</h2>
            <div className="contact-items">
              {contactItems.map((item) => (
                <a key={item.title} href={item.link} target="_blank" rel="noreferrer" className="contact-item">
                  <span className="contact-item__icon">{item.icon}</span>
                  <div className="contact-item__text">
                    <span className="contact-item__title">{item.title}</span>
                    <span className="contact-item__value">{item.value}</span>
                  </div>
                  <svg className="contact-item__arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M7 17L17 7M7 7h10v10"/>
                  </svg>
                </a>
              ))}
            </div>

            <div className="contact-info__note">
              <span>💡</span>
              <p>For sponsorships or collaborations, please include details about your product and target audience. I typically respond within 2-3 business days.</p>
            </div>
          </div>

          <div className="contact-form-card">
            {sent ? (
              <div className="contact-success">
                <div className="contact-success__icon">🎉</div>
                <h3>Message Sent!</h3>
                <p>Thanks for reaching out. I'll get back to you within 2-3 business days.</p>
                <button onClick={() => { setSent(false); setForm({ name: '', email: '', subject: '', message: '' }); }} className="btn btn--primary">
                  Send another
                </button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <h2 className="contact-form__title">Send a message</h2>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Name</label>
                    <input name="name" value={form.name} onChange={handleChange} type="text" placeholder="Your name" className="form-input" required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Email</label>
                    <input name="email" value={form.email} onChange={handleChange} type="email" placeholder="your@email.com" className="form-input" required />
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Subject</label>
                  <input name="subject" value={form.subject} onChange={handleChange} type="text" placeholder="What's this about?" className="form-input" required />
                </div>
                <div className="form-group">
                  <label className="form-label">Message</label>
                  <textarea name="message" value={form.message} onChange={handleChange} placeholder="Tell me more..." className="form-input form-textarea" rows={5} required />
                </div>
                <button type="submit" className="btn btn--primary contact-form__submit">
                  Send Message
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/>
                  </svg>
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default Contact;
